<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" class="dialog-title">
  <div>
    <h3>{{message | translate}}</h3>
  </div>
  <mat-icon id="close-dialog-button" (click)="closing.emit()" *ngIf="!disableClose">close</mat-icon>
</div>
